import * as PIXI from "pixi.js";
import { QuestionType, ShapeColor } from "../types/Enum";
import { Coord } from "../../../../../src/types/Interface";


export default class Shape extends PIXI.Container {
	private shape = this.addChild(new PIXI.Graphics());
	private shapeLabel!: PIXI.Text;
	private color: ShapeColor;

	constructor(text: string, color: ShapeColor) {
		super();
		this.color = color;
		this.addLabel(text);
	}
	setShapeLabelRot = (rot: number) => this.shapeLabel.rotation = rot;
	drawLabel = (coord: Coord) => Object.assign(this.shapeLabel, coord);
	addLabel(text: string) {
		this.shapeLabel = this.addChild(new PIXI.Text({ text }));
		this.shapeLabel.anchor.set(.5);
		this.shapeLabel.style = {
			fontSize: 30,
			fontWeight: "600",
			fill: this.color
		}
		this.clearLabel();
	}
	draw(shapeCoords: Coord[], centerCoord: Coord, qType: QuestionType) {
		this.drawShape(shapeCoords);
		qType == QuestionType.TYPE2 ? this.drawLabel(centerCoord) : this.clearLabel()
	}
	drawShape(shapeCoords: Coord[]) {
		this.shape.clear();
		shapeCoords.forEach((c, cI) => {
			if (cI == 0) { return this.shape.moveTo(c.x, c.y) }

			this.shape.lineTo(c.x, c.y);

			if (cI == shapeCoords.length - 1) {
				this.shape
					.lineTo(shapeCoords[0].x, shapeCoords[0].y)
					.stroke({ width: 7, color: this.color, cap: "round" })
			}
		})
	}
	clearAll() {
		this.shape.clear();
		this.clearLabel();
	}
	clearLabel() {
		this.shapeLabel.x = -100;
		this.shapeLabel.y = -100;
		this.shapeLabel.rotation = 0;
	}
}